module.exports = __webpack_public_path__ + "img/getac-logo.d339988e.svg";